export const enum PropertySavedStoreEvent {
  sync = 'sync',
  firstLoading = 'firstLoading',
  clear = 'clear',
  unsave = 'unsave',
}
